import { baseSettingsApi } from "./redux";

export const SettingsCoreMiddlewares = [
  baseSettingsApi.middleware,
];

export const SettingsCoreReducers = {
  [baseSettingsApi.reducerPath]: baseSettingsApi.reducer,
};